<template>
  <div>





<br>

<h4 class="grammatikparagrafbredd leftorient">Relativa pronomen i alla genus, numerus och kasus</h4><br>

<div class="grammatikparagrafbredd leftorient">
    <table class="">

        <tr class="leftorient">
            <td></td>
            <td class="ljusgra">mask.</td>
            <td  class="ljusgra">neutr.</td>
            <td class="ljusgra">fem.</td>
            <td class="ljusgra">plur.</td>
        </tr>

        <tr class="leftorient">
            <td class="ljusgra">nom.</td>
            <td class="vit">der</td>
            <td class="vit">das</td>
            <td class="vit">die</td>
            <td class="vit">die</td>
        </tr>

        <tr class="leftorient">
            <td class="ljusgra">ack.</td>
            <td class="vit">den</td>
            <td class="vit">das</td>
            <td class="vit">die</td>
            <td class="vit">die</td>
        </tr>

        <tr class="leftorient">
            <td class="ljusgra">dat.</td>
            <td class="vit">dem</td>
            <td class="vit">dem</td>
            <td class="vit">der</td>
            <td class="bggul"><b>denen</b></td>
        </tr>

        <tr class="leftorient">
            <td class="ljusgra">gen.</td>
            <td class="vit bggul"><b>dessen</b></td>
            <td class="vit bggul"><b>dessen</b></td>
            <td class="vit bggul"><b>deren</b></td>
            <td class="vit bggul"><b>deren</b> </td>
        </tr>
    </table>

<br>


<div class="quasi-p">Låt oss nu titta på några mer komplicerade fall, där korrelatet och det relativa pronomenet inte
    alltid står i nominativ (subjektsform). Det kan mycket väl vara så att korrelatet och det relativa pronomenet
    står i helt olika kasus p.g.a. att de har helt olika grammatiska funktioner i huvudsats och bisats. Då måste man tänka på
    att när det gäller det relativa pronomenet: <div class="understryk" style="background-color: lightgreen;">Genus / plural</div> avgörs av
    <div class="understryk" style="background-color: lightgreen;">korrelatet</div> , <div class="understryk" style="background-color: pink;">kasus</div>
    avgörs av pronomenets
    <div class="understryk" style="background-color: pink;">funktion i bisatsen</div>.
</div>




<br>
<div class="ruta">
<div class="quasi-p">
<div class="upp"><i>Där står </i> </div>
<div class="p-stil"><div class="dubbelrad"><i><u>mannen</u>&nbsp; <b>som</b></i> &nbsp; <br><div>&nbsp;&nbsp;<Bakatpil/></div></div></div>
<div class="upp"><i>jag känner.</i></div>
</div>
<div class="quasi-p">
<div class="upp"><i>Da steht  </i> </div>
<div class="p-stil"><div class="dubbelrad"><i><u>der Mann</u>,&nbsp; <b>den</b></i> &nbsp; <br><div>&nbsp;&nbsp;&nbsp;&nbsp;<Bakatpil/></div></div></div>
<div class="upp"><i>ich kenne.</i></div>
</div>

<p class="minitext">Korrelatet är maskulinum, det relativa pronomenet står i ackusativ i bisatsen.</p>


<br><br>

<div class="quasi-p">
<div class="upp"><i>Känner du </i> </div>
<div class="p-stil"><div class="dubbelrad"><i><u>mannen</u>&nbsp; <b>som</b></i> &nbsp; <br><div>&nbsp;&nbsp;<Bakatpil/></div></div></div>
<div class="upp"><i>står där.</i></div>
</div>
<div class="quasi-p">
<div class="upp"><i>Kennst du  </i> </div>
<div class="p-stil"><div class="dubbelrad"><i><u>den Mann</u>,&nbsp; <b>der</b></i> &nbsp; <br><div>&nbsp;&nbsp;&nbsp;&nbsp;<Bakatpil/></div></div></div>
<div class="upp"><i>da steht.</i></div>
</div>

<p class="minitext">Korrelatet är maskulinum (står i ackusativ i huvudsatsen), det relativa pronomenet står i nominativ i bisatsen.</p>


<br><br>

<div class="quasi-p">
<div class="upp"><i>Där sitter  </i> </div>
<div class="p-stil"><div class="dubbelrad"><i><u>barnet</u>&nbsp; <b>som</b></i> &nbsp; <br><div>&nbsp;&nbsp;<Bakatpil/></div></div></div>
<div class="upp"><i>du gav en blomma.</i></div>
</div>
<div class="quasi-p">
<div class="upp"><i>Da sitzt </i> </div>
<div class="p-stil"><div class="dubbelrad"><i><u>das Kind</u>,&nbsp; <b>dem</b></i> &nbsp; <br><div>&nbsp;&nbsp;&nbsp;&nbsp;<Bakatpil/></div></div></div>
<div class="upp"><i>du eine Blume gabst.</i></div>
</div>

<p class="minitext">Korrelatet är neutrum, det relativa pronomenet står i dativ i bisatsen.</p>

</div>
<br><br>


<h4 class="grammatikparagrafbredd leftorient">Preposition som inleder relativ bisats</h4>

<div class="quasi-p">Om en <i>preposition</i> i den relativa bisatsen hör samman med det relativa pronomenet har svenskan en ganska ovanlig
    konstruktion med att sätta den prepositionen sist i satsen.
    På <div class="understryk">tyskan</div> däremot, måste <div class="understryk">prepositionen</div> stå <div class="understryk">
        framför</div> ett relativt pronomen. </div>

<br><br>
<div class="ruta">
<div class="quasi-p">
<div class="upp"><i>Där bor  </i> </div>
<div class="p-stil"><div class="dubbelrad"><i><u>barnen</u>&nbsp; <b>som</b></i> &nbsp; <br><div>&nbsp;&nbsp;<Bakatpil/></div></div></div>
<div class="upp"><i>Kalle leker med.</i></div>
</div>
<div class="quasi-p">
<div class="upp"><i>Da wohnen </i> </div>
<div class="p-stil"><div class="dubbelrad"><i><u>die Kinder</u>,&nbsp; mit <b>denen</b></i> &nbsp; <br><div>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<BakatpilStor/></div></div></div>
<div class="upp"><i>Kalle spielt.</i></div>
</div>

<p class="minitext">Korrelatet är plural, bisatsen inleds med prepositionen "mit" som gör att det relativa pronomenet står i dativ.</p>
</div>

<br><br>
<h4 class="grammatikparagrafbredd leftorient">Ägande relativt pronomen - vars</h4>



<p>Slutligen tittar vi på de fall när det relativa pronomenet står i genitiv, ägandeform.
    Där använder vi på svenska ordet <i>vars</i>, men på tyska är det samma typ av
    relativa pronomen, bara att de står i genitivform. Där skiljer de sig dock från motsvarande bestämda artiklar.</p>



    <br><br>

<div class="ruta">
    <div class="quasi-p">
    <div class="upp"><i>Jag såg  </i> </div>
    <div class="p-stil"><div class="dubbelrad"><i><u>författarinnan</u>&nbsp; <b>vars</b></i> &nbsp; <br><div>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<Bakatpil/></div></div></div>
    <div class="upp"><i>senaste bok har blivit oerhört populär.</i></div>
    </div>
    <div class="quasi-p">
    <div class="upp"><i>Ich sah </i> </div>
    <div class="p-stil"><div class="dubbelrad"><i><u>die Autorin</u>,&nbsp; <b>deren</b></i> &nbsp; <br><div>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<BakatpilStor/></div></div></div>
    <div class="upp"><i>neuestes Buch unheimlich populär geworden ist.</i></div>
    </div>

    <p class="minitext">Korrelatet är femininum, därför blir "vars" också feminint.</p>


    <br><br>

    <div class="quasi-p">
    <div class="upp"><i>Den kände </i> </div>
    <div class="p-stil"><div class="dubbelrad"><i><u>kocken</u>&nbsp; <b>vars</b></i> &nbsp; <br><div>&nbsp;&nbsp;<Bakatpil/></div></div></div>
    <div class="upp"><i>matlagning jag älskar, är bara 27 år gammal.</i></div>
    </div>
    <div class="quasi-p">
    <div class="upp"><i>Der berühmte </i> </div>
    <div class="p-stil"><div class="dubbelrad"><i><u>Koch</u>,&nbsp; <b>dessen</b></i> &nbsp; <br><div>&nbsp;&nbsp;&nbsp;<Bakatpil/></div></div></div>
    <div class="upp"><i>Küche ich liebe, ist nur 27 Jahre alt.</i></div>
    </div>

    <p class="minitext">Korrelatet är maskulinum, därför blir "vars" också maskulint.</p>
</div>
<br><br>
</div>
</div>


</template>

<script>
import Bakatpil from '../grafik/bakatpil.vue'
//import BakatpilLiten from '../grafik/bakatpilLiten.vue'
import BakatpilStor from '../grafik/bakatpilStor.vue'

export default {
  name: 'Grammatik',
  components: {
    Bakatpil,
    //BakatpilLiten,
    BakatpilStor
},

metaInfo() {
    return {
        meta: [
            {
                vmid: "description",
                name: "description",
                content: "relativa pronomen som vars"
            }
        ]
    }
},

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>


</style>
